import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { BookingProvider } from "@/context/BookingContext";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BookingProvider>
            <BrowserRouter>
              <SmoothScroll>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<Article />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </SmoothScroll>
            </BrowserRouter>
          </BookingProvider>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#111111",
                color: "#F5F5F5",
                border: "1px solid #12C98A",
                borderRadius: "0px",
                fontFamily: "'Space Mono', monospace",
                fontSize: "13px",
              },
            }}
          />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
